'use strict';

import { Entity } from '../Entity';
import { App } from '../App';
import { Agency } from './Agency';
//import { UserIntegrationProvider } from './User/UserIntegrationProvider';

export class AgencyConnecture extends Entity {
  protected id;
  protected agency;
  protected url;
  protected urlRelay;
  protected clientId;
  protected application;
  protected partnerId;
  protected apiKey;
  protected apiSecret;
  protected orgName;
  protected reference;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.url = data.url;
    this.urlRelay = data.urlRelay;
    this.clientId = data.clientId;
    this.application = data.application;
    this.partnerId = data.partnerId;
    this.apiKey = data.apiKey;
    this.apiSecret = data.apiSecret;
    this.orgName = data.orgName;
    this.reference = data.reference;

    if (data.agencyId) {
      const agency = new Agency();

      agency.hydrate(data.agency);

      this.agency = agency;
    }
  }

  public getUrl() {
    return this.url;
  }

  public getUrlRelay() {
    return this.urlRelay;
  }

  public getClientId() {
    return this.clientId;
  }

  public getApplication() {
    return this.application;
  }

  public getPartnerId() {
    return this.partnerId;
  }

  public getApiKey() {
    return this.apiKey;
  }

  public getApiSecret() {
    return this.apiSecret;
  }

  public getOrgName() {
    return this.orgName;
  }

  public getReference() {
    return this.reference;
  }

  public getId() {
    return this.id;
  }
}
